import { connect } from 'react-redux'
import { selectors } from '../../../../../imports'
import { getPlayerText, getPlayersText } from '../../../../../data'
import Counter from './component'

function mapStateToProps(state, ownProps) {
    const locale = selectors.getLocale(state)

    const spaceLanguages = ['fr', 'ru']
    const separator = spaceLanguages.indexOf(locale) === -1 ? ',' : ' '

    const result = {
        count: ownProps.count,
        textFirst: ['ru'].indexOf(locale) > -1,
        thousandSeparator: separator,
        counterTextSingular: getPlayerText(state),
        counterTextPlural: getPlayersText(state),
    }

    return result
}

export default connect(mapStateToProps)(Counter)



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/AnimatedCounter/Counter/index.js